const content = {
    'en-EN': {
        nickNamePLCHLDR: "Choose a Nickname",
        passwordPLCHLDR: "Choose a Password",
        emailPCHLDR: "Enter Your Email",
        emailVal1: "Please enter your email address",
        passVal1: "Please enter a password",
        passVal2: "Please enter at least 6 letters",
        passVal3: "Password should be between 6 to 64 characters.Only these special characters @#$%& !^* ()_ +-= are allowed",
        passVal4: "Password must start with a letter",
        userVal1: "Must contain a minimum of 6 characters",
        userVal2: "User Name should contain only digits and letters",
        userVal3: "Your username may not contain any symbols nor start with a number",
        userVal4: "This nickname is already taken. Please choose a different one",
        userLoading: "checking...",
        h1: "CREATE YOUR FREE ACCOUNT",
        h2: "Your membership and your access to our webcams are free forever",
        submit: "JOIN FOR FREE",
        footer1: "By clicking on the button above, you confirm your registration and agree to all of the ",
        footer2: "Terms of Use",
        footer3: " and ",
        footer4: "Privacy Policy",
        TU1: "Thank you for joining ",
        TU2: "!",
        TU3: "Your discreet user is being created",
        TU4: "You will be redirected to the full webcam experience in:"
    },
    'de-DE': {
        nickNamePLCHLDR: "Wähle einen Benutzernamen",
        passwordPLCHLDR: "Wähle ein Passwort",
        emailPCHLDR: "Deine Email eingeben",
        emailVal1: "Bitte deine Email eingeben",
        passVal1: "Bitte Passwort eingeben",
        passVal2: "Passwort muss mindestens 6 Buchstaben enthalten",
        passVal3: "Das Passwort sollte zwischen 6 und 64 Zeichen lang sein. Nur diese Sonderzeichen @#$%& !^* ()_ +-= sind erlaubt",
        passVal4: "Das Passwort muss mit einem Buchstaben beginnen",
        userVal1: "Passwort muss mindestens 6 Zeichen enthalten",
        userVal2: "Benutzername darf nur Ziffern und Buchstaben enthalten",
        userVal3: "Benutzername darf keine Symbole enthalten oder mit einer Ziffer beginnen",
        userVal4: "Dieser Benutzername ist bereits vergeben.Bitte wähle einen anderen",
        userLoading: "Überprüfung...",
        h1: "Account frei erstellen",
        h2: "Ihre Mitgliedschaft und Ihr Zugang  zu unseren Webcams sind für immer frei",
        submit: "Kostenlos melden",
        footer1: "Wenn Sie diesen Knopf unten drücken, bestätigen Sie Ihre Registrierung  und erklären sich mit allen   ",
        footer2: "Nutzungsbedingungen",
        footer3: "  und ",
        footer4: "Datenschutzbestimmungen einverstanden",
        TU1: "Vielen Dank dass Du für ",
        TU2: " angemeldet hast",
        TU3: "Dein diskreter Benutzer wird erstellt",
        TU4: "Du wirst zur vollständigen Webcam-Erfahrung weitergeleitet in:"
    },
    'ru-RU': {
        nickNamePLCHLDR: "Подберите себе имя",
        passwordPLCHLDR: "Подберите себе пароль",
        emailPCHLDR: "Введи свой email",
        emailVal1: "Пожалуйста, введите ваш email адрес",
        passVal1: "Пожалуйста, введите ваш пароль",
        passVal2: "Пожалуйста, введите как минимум 6 букв",
        passVal3: "Длина пароля должна составлять от 6 до 64 символов. Разрешены только специальные символы @#$%& !^* ()_ +-=.",
        passVal4: "Пароль должен начинаться с буквы",
        userVal1: "Должен содержать минимум 6 символов",
        userVal2: "Имя пользователя должно содержать только цифры и буквы",
        userVal3: "Ваше имя пользователя не должно содержать никаких символов и начинаться с цифры",
        userVal4: "Это имя уже занято, Пожалуйста, выбери, другое",
        userLoading: "проверка...",
        h1: "Создай свой аккаунт бесплатно",
        h2: "Твой доступ на нашей вебкам-платформе будет всегда бесплатным",
        submit: "Зарегистрироваться",
        footer1: "При нажатии на кнопку ниже, вы подтверждаете регистрацию и соглашаетесь со всеми ",
        footer2: "Правилами использования",
        footer3: " и ",
        footer4: "Политикой конфиденциальности",
        TU1: "Спасибо, что присоединились к ",
        TU2: "!",
        TU3: "Мы создаем вашего тайного пользователя",
        TU4: "Вы будете перенаправлены для погружения в вебкам опыта..."
    },
}

export default content;